import React, { useState } from 'react';
import { Navbar } from '../navbar/Navbar';
import { Col, Row } from 'reactstrap';
import { OrderPage } from './OrderPage';
import { OrderDetail } from './OrderDetail';
import { FoodMenu } from '../component/FoodMenu';
import { OrgTable } from './OrgTable';

export const OrgPos = () => {
    const [selectedMenu, setSelectedMenu] = useState('food');
    const [orderId, setOrderId] = useState(null);

    const handleOrderClick = (id) => {
        setOrderId(id);
        setSelectedMenu('order-detail');
    };

    const renderComponent = () => {
        switch (selectedMenu) {
            case 'table':
                return <OrgTable />;
            case 'order':
                return <OrderPage onOrderSelect={handleOrderClick} />;
            case 'order-detail':
                return <OrderDetail orderId={orderId} />;
            case 'food':
            default:
                return <FoodMenu />;
        }
    };



    return (
        <>
            <Navbar setSelectedMenu={setSelectedMenu} selectedMenu={selectedMenu} />

            <Row className='w-100 mt-5 '>
                <Col md={12} className='mt-2'>
                    {renderComponent()}  {/* Fixed: Added parentheses to call the function */}
                </Col>
            </Row>

           

        </>
    );
};